module.exports = __webpack_public_path__ + "static/products-by-category-is-not-rendering-43bfdc9d8531cb8e77f44d4806a6c8c0.png";